"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Button — the only button in the product.
 * Implements surface-identity-and-shell.md §4.
 *
 * Variants:
 *   primary | secondary | ghost   unchanged from design-system v1.0.0
 *   danger                        Delete, Undeploy, Delete selected
 *   onDark                        every control inside the navy bands
 *
 * `danger` + confirm renders the solid red fill, which is used ONLY inside the
 * shared confirmation modal — never as a status colour.
 *
 * Two states that are easy to confuse, and must not be:
 *   `launch`  — this button opens ANOTHER application in a new tab (Console's
 *               Designer / Explorer). Tinted blue. Nothing else may use it.
 *   `active`  — the current view, or a toggle whose panel is open. Stays within
 *               the app, so it gets a pressed treatment on the ordinary button.
 * A view switcher is `active`, never `launch`.
 * `onDark` + ghost is the transparent outlined form used in the masthead.
 * `active` marks the current view in a switcher (onDark only).
 *
 * Labels are Title Case verbs, two words maximum. Icon-only buttons MUST pass
 * an aria-label; that is enforced below in development.
 */const VARIANTS = ['primary', 'secondary', 'ghost', 'danger', 'onDark'];
const Button = ({
  variant = 'secondary',
  ghost = false,
  confirm = false,
  active = false,
  launch = false,
  iconOnly = false,
  className = '',
  children,
  ...rest
}) => {
  if (process.env.NODE_ENV !== 'production') {
    if (!VARIANTS.includes(variant)) {
      console.warn(`[@cloudsam/ui] Button: unknown variant "${variant}". Use one of ${VARIANTS.join(', ')}.`);
    }
    if (iconOnly && !rest['aria-label']) {
      console.warn('[@cloudsam/ui] Button: icon-only buttons require an aria-label.');
    }
  }
  const classes = ['btn', `btn--${variant}`, ghost ? 'btn--ghost-mod' : '', confirm ? 'btn--confirm' : '', active ? 'is-active' : '', launch ? 'btn--launch' : '', iconOnly ? 'btn--icon' : '', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    className: classes,
    ...rest,
    children: children
  });
};
var _default = exports.default = Button;